import { h } from "preact";
function CreatorDesc(props) {
    const { description, baseIngredients } = props;
    return (h("div", { class: "m-product-card__desc" },
        h("p", { class: "u-small-spacing-b" }, description),
        h("p", { class: "u-small-spacing-b", "data-field-id": "Creator.baseIngredients", "data-field-type": "info" }, baseIngredients)));
}
export default CreatorDesc;
